import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=65e5f2f8&scoped=true"
import script from "./ContentList.vue?vue&type=script&lang=js"
export * from "./ContentList.vue?vue&type=script&lang=js"
import style0 from "./ContentList.css?vue&type=style&index=0&id=65e5f2f8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5f2f8",
  null
  
)

export default component.exports